import React from "react";
import { createBrowserRouter } from "react-router-dom";
import HomePageRouteWrapper from "./pages/home/index";
import Error from "./pages/error";
import Login from "./pages/login";
import RequireAuth from "./components/auth/RequireAuth";
import FinishLogin from "./pages/finish-login";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Logout } from "./components/auth/Logout";

import UserPageRouteWrapper from "./pages/users";
import AlertsPageRouteWrapper from "./pages/alerts";
import RiskmapPageRouteWrapper from "./pages/riskmap";
import RulesPageRouteWrapper from "./pages/rules";
import SensorsPageRouteWrapper from "./pages/sensors";
import FindingJsonViewerPage from "./pages/finding";

const queryClient = new QueryClient();

export const router = createBrowserRouter([
  {
    path: "/users",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <UserPageRouteWrapper />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/sensors",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <SensorsPageRouteWrapper />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/sensors/:sensor_id",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <>Not implemented</>
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/alerts",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <AlertsPageRouteWrapper />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/riskmap",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <RiskmapPageRouteWrapper />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/rules",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <RulesPageRouteWrapper />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },

  {
    path: "/finding/:event_id",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <FindingJsonViewerPage />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <QueryClientProvider client={queryClient}>
          <HomePageRouteWrapper />
        </QueryClientProvider>
      </RequireAuth>
    ),
    errorElement: <Error />,
  },
  {
    path: "/login",
    element: <Login />,
    errorElement: <Error />,
  },
  {
    path: "/logout",
    element: <Logout />,
    errorElement: <Error />,
  },

  {
    path: "/finish-login",
    element: <FinishLogin />,
    errorElement: <Error />,
  },
]);
